import { Component, OnInit } from '@angular/core';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { Subject, Observable } from 'rxjs';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';

@Component({
  selector: 'smt-total-uos-summary',
  templateUrl: './total-uos-summary.component.html',
  styleUrls: ['./total-uos-summary.component.scss']
})
export class TotalUosSummaryComponent implements OnInit {

  filters:ReportFilters;
  defaultFilters:ReportFilters;
  eventsSubject: Subject<void> = new Subject<void>();
  eventObservable: Observable<void>;

  constructor(private reportService: ReportService){
  }

  ngOnInit() {
    this.filters = new ReportFilters();
    this.filters.ReportView = 'Pay Period Ending';
    this.filters.isSummary = true;
    this.defaultFilters = new ReportFilters();
    this.eventObservable = this.eventsSubject.asObservable();    
    this.reportService.announceSummarySelected(Constants.TotalUosSummary);
  } 

  filterUpdated(filters: ReportFilters) {
      this.filters = filters;
      setTimeout(() => this.eventsSubject.next(), 1);
  }

}
